import React, { Fragment } from 'react';
import classNames from 'classnames';
import { Row, Col, Container, Heading } from 'seduo-ui';
const CarouselCaption = ({ imageUrl, imageWidth, imageHeight, imageSrcSet, imageSizes, title, text, roundedImage, verticalDirection, }) => {
    let srcSetValue = null;
    if (imageSrcSet) {
        const { small, smallWidthDescriptors, medium, mediumWidthDescriptors } = imageSrcSet;
        srcSetValue = `${small} ${smallWidthDescriptors}, ${medium} ${mediumWidthDescriptors}`;
    }
    return (<Container>
            <Row>
                <Col md={verticalDirection ? 12 : 3} lg={verticalDirection ? 12 : 2}>
                    <Row className={classNames('carousel-item__wrapper', 'carousel-item__wrapper--image')}>
                        <img className={classNames({
            'rounded-circle': roundedImage,
            'mb-8': verticalDirection,
        })} width={imageWidth} height={imageHeight} src={imageUrl} srcSet={srcSetValue} sizes={imageSizes} alt={title}/>
                    </Row>
                </Col>
                <Col md={verticalDirection ? 12 : 9} lg={verticalDirection ? 12 : 10}>
                    <Row className="carousel-item__wrapper">
                        {verticalDirection ? (<Fragment>
                                <Heading level={3} className="carousel-item__caption">
                                    {title}
                                </Heading>
                                <p className={classNames('carousel-item__text', 'text-muted', {
                'carousel-item__text--vertical': verticalDirection,
            })}>
                                    {text}
                                </p>
                            </Fragment>) : (<Fragment>
                                <Heading level={3} className={classNames('carousel-item__caption', 'carousel-item__caption--left')}>
                                    {title}
                                </Heading>
                                <p className="carousel-item__text">{text}</p>
                            </Fragment>)}
                    </Row>
                </Col>
            </Row>
        </Container>);
};
CarouselCaption.defaultProps = {
    roundedImage: true,
    verticalDirection: false,
    imageSrcSet: null,
    imageSizes: null,
};
export default CarouselCaption;
